<template>
<div class="container-fluid" >

 <div class="card border-success">

  <div class="card-header text-white bg-primary">
    <h4><i class="fas fa-camera mr-2" aria-hidden="true"></i>CATALOGO FORNITORE</h4>
  </div> 

 <div  class="card-body"> 
  

<div class="row">
<div v-if="items.length==0" class="col-md-4"> 

  <div class="card border-info" >
  <div class="card-header  bg-info"><strong>PARAMETRI DI RICERCA</strong></div>
  <div class="card-body text-dark">


  <form name="movementSearch" v-on:submit.prevent="submit()">
    <!--
    <supplier-select v-bind:props="supplier" @update="setSupplierId"></supplier-select>    
    -->  
    <brand-list v-bind:props="brand" @update="setBrandId"></brand-list>      
   
   <!-- <line-select :key="refreshLine" v-bind:optionBase="true"  v-bind:supplierId="supplier.Id" v-bind:isActive="items.length==0" @update="setLineId"></line-select>-->
    <season-select v-bind:props="season"  @update="setSeasonId"></season-select>
    <year-select  v-bind:props="season_year" @update="setYear"></year-select>
    <department-select v-bind:props="department" @update="setDepartmentId"></department-select>
    <category-select v-bind:props="categoryGroup"  @update="setCategoryId"></category-select>
    
    <stock-filter class="ml-4 mt-1 mb-1" @update="setStockFilter"></stock-filter>

    <div class="card-footer bg-transparent border-info"> 
      <alert-box  @close="msg.title=''" v-bind:msg="msg"  ></alert-box>  
        <button :disabled="spinner" type="submit"  class="btn btn-primary float-right">
          <i class="far fa-play-circle mr-2"></i>
          ESEGUI
          <span v-if="spinner" class="spinner-border spinner-border-sm ml-3 text-warning" role="status" aria-hidden="true"></span>
        </button>   

        
    </div>

  </form>
  

  </div>
</div>
</div>


<div v-else class="col">

  <button v-if="items.length>0"  @click="items=[],stock=1" type="button"  class="btn btn-secondary mb-3">
    <i class="fas fa-reply mr-2"></i>
    ANNULLA
  </button> 

<div class="catalog mb-3">
<ul class="list-unstyled pointer"  :class="`index-${index}`" @dblclick="openDetail(index)" v-for="(item, index) in items" :key='index'>
  <li class="media">

     
     <img  @error="setAltImg" @click="imgZoom(item.img)" v-bind:src="item.img" alt="" width="100" height="100"  class="rounded mr-3">  
         
    <div class="media-body">
      
      <h5 class="mt-0 mb-1"><strong> {{item.productId}} </strong>
      <span :class="{dotRed:item.sale_qty == 0}"></span>
      </h5>

      <h5 class="mt-0 mb-1">{{item.brand}} [{{item.sku}}] {{item.category}} </h5>

      <h4>
        {{item.color}}
      </h4>
      <h4>
        <span class="badge badge-success">Stock {{item.qty}}</span>
        </h4>
      <h4>€ {{fmt1(item.price)}}</h4>

      <div v-if="isOpen[index]==true" class="ml-4 mr-4">
        <component :key = "componentKey" v-bind:spinner="spinner1" v-bind:is="component" v-bind:cols="cols" v-bind:rows="rows"></component>          
        <span v-if="spinner1" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> 
      </div>

    </div>

  </li>
 
</ul>
</div>

  
<img-zoom v-if="img" @close="closeImg()" v-bind:img='img'></img-zoom>

</div>
</div>
</div>
</div>
</div>


</template>
<script>
import api               from "@/api";
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';
import supplierSelect    from '@/components/common/SupplierSelect_1.vue'
import seasonSelect      from '@/components/common/SeasonSelect_1.vue'
import yearSelect        from '@/components/common/YearSelect_1.vue'
import departmentSelect  from '@/components/common/DepartmentSelect_1.vue'
import categorySelect    from '@/components/common/CategoryGroupingSelect_1.vue'
import productStock      from '@/components/common/ProductStock.vue'
import lineSelect        from '@/components/common/LineSelect.vue'
import brandList         from '@/components/common/CompanyBrandSelect_1.vue'

import imgZoom           from '@/components/common/ProductImg.vue'
import stockFilter       from '@/components/common/StockFilter.vue'


export default {
  components: {alertBox,supplierSelect,seasonSelect,yearSelect,departmentSelect,categorySelect,productStock,lineSelect,imgZoom,brandList,stockFilter},
  data() {
    return {


      brand           :
      {
        Id            : '',
        required      : true,

      },
      supplier        : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true

      },
      season          : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        type          : true


      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true

      },
      department      : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : false,
        required      : true,
       
      },
      categoryGroup   : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : false,
        required      : true,
       
      },
      isOpen          : [], 
      component       : '', 
      
      lineId          : 0,
            
      spinner1        : false,
      spinner         : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
    
      items           : [],
      detail          : [], 
      cols            : [],
      rows            : [],
      componentKey    : 0,
      refreshLine     : 0,
      stock           : 1,
      img             : '',
      
      
      
    };
  },

  computed :{
    ...mapGetters(['company']),
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {
    
   
  },
  methods: {
    scrollToElement(options) {
      const el = this.$el.getElementsByClassName('index-0')[0];
      
      if (el) {
        el.scrollIntoView(options);
      }
    },
    setAltImg(event) 
    { 
        event.target.src = require("@/assets/no_img.jpg")
    },         
 
    imgZoom(img)
    {
        this.img = img
    },
    closeImg()
    {
        this.img = ''
    },
    openDetail(index)
    {
    
      this.isOpen        = []
      this.spinner1      = true
      this.isOpen[index] = true

      
      var data  = {
        'productId':this.items[index]['productId'],'colorId':this.items[index]['colorId'] 
      }

      var arr        = []
      var sizes      = []
      arr            = this.detail.filter(item=>item.productId == data.productId && item.colorId == data.colorId)
      sizes          = arr[0].data.split(',')
      this.component = ''
      var cols       = []
      
      this.cols      = []
      this.rows      = []
      
      this.cols.push('store')
      this.cols.push('color')
      this.cols.push('qty')
   
      cols = arr[0]['header'].split('|')
      cols.forEach(item=>{
        this.cols.push(item)
      })
      
  
      arr.forEach(item=>{
        var  data = item.data.split(',');
  
      data.forEach(row=>{
        var size = row.split('|')
        item[size[0]] = size[1]
      })

      })
      this.rows = arr
  
      this.component = 'productStock'
      this.componentKey++
      this.spinner1 = false   
      

      
    },

    fmt1(value)
    { 
      if(!isNaN(value))
      {
      return Number(value).toLocaleString('it-IT',{ style: 'decimal',minimumFractionDigits: 2 ,maximumFractionDigits: 2});
      }
    },

    setBrandId(brandId)
    {
      this.brand.Id = brandId
      

    },
    setCategoryId(categoryId)
    {      
      this.categoryGroup.Id = categoryId
    },  
    setSupplierId(supplierId)
    {
        this.supplier.Id = supplierId        
        this.refreshLine++
    },  
    setDepartmentId(departmentId)
    {
      this.department.Id = departmentId
    },
    setSeasonId(seasonId)
    {   
        
        this.season.Id = seasonId
    },  
    setYear(year)
    {
        this.season_year.year = year
    },
    setLineId(lineId)
    {
      this.lineId = lineId
    },
    setStockFilter(stock)
    {
      this.stock = stock
    },
    submit() 
    {
      this.getData()
      
    },  
    
      
    
    async getData() {
      
      this.isOpen = []
      this.cols   = []
      this.rows   = []
      this.err    = []
      this.items  = []
      
  
      this.msg.title = ''
      var sp = {'sp' : 'spSupplierCatalog'}
      
      var data  = {

        'companyId' : this.company.Id,'supplierId' : this.supplier.Id,'seasonId' : this.season.Id,
        'departmentId' : this.department.Id,'categoryId' : this.categoryGroup.Id,
        'season_year' : this.season_year.year,'lineId':this.lineId,'stock':this.stock,
        'brand': this.brand.Id

      }
      
      var json  = Object.assign(data, sp)      
      this.spinner = true


      

      await api.post(json).then(res => {
         
          if(res.status==200)
            {
              this.items = res.data.recordsets[0]
              this.detail = res.data.recordsets[1]  
              this.$nextTick(function () 
              {
                this.scrollToElement()
              })                
                 
              if(this.items.length==0)
              {
               
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }

            }
            else if (res.status==500)
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

           
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
                        

          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
        

      }).finally(() => {
          this.spinner = false
        });
      

    }
  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position: relative;
height: 700px;
overflow: auto;
}
.pointer:hover
{
  _background-color: white;
  
  cursor: pointer;
}

.detail tr:nth-child(1) th  {
    background   : yellow;
}
.master tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #66CCFF; 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 20px;
    background   : #FFFFE0;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;

 }

 .tfoot  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #66CCFF; 
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;

 }
.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}
.dotRed
{
  height: 15px;
  width: 15px;
  
  border-radius: 50%;
  display: inline-block;
  background-color: red;
}
div.catalog {
 
  height: 700px;
  _width: 200px;
  overflow-y: scroll;
}
</style>